import React, { useContext } from "react";
import ServicePage from "../servicePerformance/ServicePage";
import EngIndicator from "../../components/Kpi/FleetKpi";
import IssueStatus from "../Mainpage/IssueStatus";
import FaultCode from "../faultCodeAnalysis/Faultcode";
import SsoAnalisys from "../Mainpage/SsoAnalisys";
import BarandLinegraph from "../../components/Graph/BarandLinegraph";
import Dashboard from "../Pvin/Dashboard";
import { FilterContext } from "../../context/Filter";
import Header from "../../components/Header/Header";
import NavButtons from "../../components/NevBar/NavButtons";
import IndexPage from "../servicePerformance/IndexPage";
import WaterMark from "../../components/WaterMark";
import Search from "../../components/CustSearch/Search";
const Fleetinsight = () => {
  const { open } = useContext(FilterContext);
  return (
    <div className=" ml-4 md:ml-0 w-96 md:w-full">
      <WaterMark />
      <Header heading={"Fleet Insights"} />
      <Search />

      <Dashboard />
      <EngIndicator />
      <BarandLinegraph />
      <IssueStatus />
      <FaultCode />
      <IndexPage />
      <SsoAnalisys />
      <NavButtons />

    </div >
  );
};

export default Fleetinsight;
